import { render, staticRenderFns } from "./DreamsLog.vue?vue&type=template&id=5160d093&scoped=true"
import script from "./DreamsLog.vue?vue&type=script&lang=js"
export * from "./DreamsLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5160d093",
  null
  
)

export default component.exports